import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { VARIANTS } from '@prisjakt/ui-store-logo';

export { VARIANTS };

export const StoreInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 104px;
  padding: ${layout.measurements.spacingSmall};
  margin: 1px ${layout.measurements.spacingSmall};
  align-items: flex-start;
  gap: 2px;

  ${media.smallOnly`
    width: 90px;
    padding: ${layout.measurements.spacingTiny} ${layout.measurements.spacingSmall};
    margin: 0;
  `}
`;

export const StoreInfoTitle = styled.span`
  /* Visually hidden since this text is primarily for Google */
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
